/**
 * Runtime config, injected by `public/config.js` (local) or a ConfigMap per environment.
 *
 * Every read is guarded: this module is imported by `@/modules/shared/constants`, which most of the
 * app imports, so touching bare `window` here makes any `node`-environment test fail at collection
 * rather than at an assertion. That is not theoretical — it is why `MentionText.test.ts` could not
 * run. See §5.4 of `docs/ops-merge-context.md`.
 */
const env = typeof window !== 'undefined' ? window.env : undefined;

export const CLIENT_ID = env?.CLIENT_ID;
export const CLIENT_SECRET = env?.CLIENT_SECRET;
export const FACEBOOK_ID = env?.FACEBOOK_ID;
export const GOOGLE_ID = env?.GOOGLE_ID;
export const RECAPTCHA_ID = env?.RECAPTCHA_ID;
export const LINE_CLIENT_ID = env?.LINE_CLIENT_ID;
export const FACEBOOK_ID_SHARE = env?.FACEBOOK_ID_SHARE;
export const S3_URL = env?.S3_URL;
export const SENTRY_DSN = env?.SENTRY_DSN;
export const TRACES_SAMPLE_RATE = env?.TRACES_SAMPLE_RATE;
export const NEW_PORTAL = env?.NEW_PORTAL;
export const OLD_PORTAL = env?.OLD_PORTAL;
export const RECAPTCHA_SITEKEY = env?.RECAPTCHA_SITEKEY;

/**
 * The one base URL. Always ends in a slash.
 *
 * Falls back to a hostname rewrite when `window.env.API_URL` is absent — a real case (a missing
 * `public/config.js`), and the reason this must not be replaced by a bare `window.env` read.
 * `@/modules/shared/constants` derives `API_BASE_URL` from this rather than re-deriving it.
 */
let API_URL: string = env?.API_URL ?? '';

if (!API_URL) {
  if (typeof window === 'undefined') {
    // Non-browser (node-environment tests). Any value works; requests are mocked.
    API_URL = 'https://api.invalid/';
  } else if (window.location.hostname === 'localhost') {
    API_URL = 'https://api-fairedrevamp.lab.fairdee.co.th/';
  } else {
    API_URL = window.location.protocol + '//' + window.location.hostname.replace('portal', 'api') + '/';
  }
}

export { API_URL };
